import { defineMessages } from "react-intl";

export const twoFaFeatureMessages = defineMessages({
  blocked: {
    id: "security-alert.requirement.blocked.two-fa-caption",
    defaultMessage: "Заблокировано",
  },
  email: {
    id: "otpPage.deliveryType.email",
    defaultMessage: "Введите код из почты",
  },
  googleAuth: {
    id: "security-alert.requirement.two-fa-caption",
    defaultMessage: "Приложение-аутентификатор",
  },
  kybName: {
    id: "security-alert.kyb.name",
    defaultMessage: "Верификация компании",
  },
  kycName: {
    id: "security-alert.kyc.name",
    defaultMessage: "Подтверждение личности",
  },
  offerAccept: {
    id: "security-alert.requirement.offer-caption",
    defaultMessage: "Примите условия оферты",
  },
  offerName: {
    id: "security-alert.requirement.offer-name",
    defaultMessage: "Публичная оферта",
  },
  offerUnavailable: {
    id: "security-alert.requirement.offer-unavailable",
    defaultMessage: "Доступно после подтверждения личности",
  },
  pauseTwoFa: {
    id: "security-alert.requirement.pause.two-fa-caption",
    defaultMessage: "Временно приостановлено",
  },
  phoneNumber: {
    id: "security-alert.requirement.phone-name",
    defaultMessage: "Номер телефона",
  },
  phoneUnchecked: {
    id: "security-alert.requirement.phone-unchecked-caption",
    defaultMessage: "Подтвердите номер телефона",
  },
  phoneVerified: {
    id: "security-alert.requirement.phone-verified-caption",
    defaultMessage: "Подтверждён",
  },
  policiesCaption: {
    id: "security-alert.requirement.policies-caption",
    defaultMessage: "Ознакомьтесь и примите необходимые\nдокументы",
  },
  policiesName: {
    id: "security-alert.requirement.policies-name",
    defaultMessage: "Согласия с политиками",
  },
  questionnaireCaption: {
    id: "security-alert.requirement.questionnaire-caption",
    defaultMessage: "Заполните обязательный опросник",
  },
  questionnaireName: {
    id: "security-alert.requirement.questionnaire-name",
    defaultMessage: "Опросник о виртуальных активах",
  },
  requirementCompleted: {
    id: "security-alert.requirement.completed.two-fa-caption",
    defaultMessage: "Выполнено",
  },
  requirementPhone: {
    id: "security-alert.requirement.phone-caption",
    defaultMessage: "Подтверждение через СБП",
  },
  requirementTwoFa: {
    id: "security-alert.requirement.two-fa-name",
    defaultMessage: "Двухфакторная защита",
  },
  sms: {
    id: "otp.deliveryType.sms",
    defaultMessage: "Введите код из смс",
  },
  success: {
    id: "security-alert.requirement.success.two-fa-caption",
    defaultMessage: "Выполнено",
  },
  title: {
    id: "otpPage.title",
    defaultMessage: "Введите код {br}подтверждения",
  },
  twoFaConnected: {
    id: "security-alert.requirement.two-fa-connected-caption",
    defaultMessage: "Подключена",
  },
});

export const kycVerifyCaptionMessages = defineMessages({
  blocked: {
    id: "security-alert.kyc.blocked.caption",
    defaultMessage: "Заблокировано",
  },
  checking: {
    id: "security-alert.kyc.checking-doc.caption",
    defaultMessage: "Документы отправлены",
  },
  completed: {
    id: "security-alert.kyc.completed.caption",
    defaultMessage: "Выполнена",
  },
  pause: {
    id: "security-alert.kyc.pause.caption",
    defaultMessage: "Временно приостановлено",
  },
  rejected: {
    id: "security-alert.kyc.rejected.caption",
    defaultMessage: "Документы отклонены",
  },
  requested: {
    id: "security-alert.kyc.requested.caption",
    defaultMessage: "Нужны документы для подтверждения",
  },
  revision: {
    id: "security-alert.kyc.revision.caption",
    defaultMessage: "Требуется исправление",
  },
});

export const kybVerifyCaptionMessages = defineMessages({
  blocked: {
    id: "security-alert.kyи.blocked.caption",
    defaultMessage: "Заблокировано",
  },
  checking: {
    id: "security-alert.kyb.checking.caption",
    defaultMessage: "Заявка отправлена",
  },
  completed: {
    id: "security-alert.kyb.completed.caption",
    defaultMessage: "Выполнено",
  },
  pause: {
    id: "security-alert.kyb.pause.caption",
    defaultMessage: "Временно приостановлено",
  },
  rejected: {
    id: "security-alert.kyb.rejected.caption",
    defaultMessage: "Заявка отклонена",
  },
  requested: {
    id: "security-alert.kyb.requested.caption",
    defaultMessage: "Нужны документы для подтверждения",
  },
  revision: {
    id: "security-alert.kyb.revision.caption",
    defaultMessage: "Требуется исправление",
  },
});

export const resendButtonMessages = defineMessages({
  blocked: {
    id: "otp-form.resend-button-blocked",
    defaultMessage: "Отправить повторно через {seconds}с",
  },
  resend: {
    id: "otp-form.resend-button",
    defaultMessage: "Отправить код повторно",
  },
});

export const transactionVerifyMessages = defineMessages({
  clipboardError: {
    id: "otp-form.clipboard-error",
    defaultMessage: "Не удалось вставить из буфера обмена:",
  },
  details: {
    id: "transaction-verify-form.details",
    defaultMessage: "Детали операции",
  },
  otpCodeLabel: {
    id: "transaction-verify-form.otp-code-label",
    defaultMessage: "Отправили код на {deliveryContact}",
  },
  otpCodePlaceholder: {
    id: "otp-form.code.placeholder",
    defaultMessage: "Код",
  },
  otpEmailLabel: {
    id: "transaction-verify-form.otp-email-label",
    defaultMessage: "Код из письма, отправлен на {contact}",
  },
  otpSmsLabel: {
    id: "transaction-verify-form.otp-sms-label",
    defaultMessage: "Код из SMS, отправлен на {contact}",
  },
  pasteButton: {
    id: "otp-form.paste-button",
    defaultMessage: "Вставить",
  },
  submitButton: {
    id: "transaction-verify-form.submit-button",
    defaultMessage: "Подтвердить",
  },
  totpCodeLabel: {
    id: "transaction-verify-form.totp-code-label-2",
    defaultMessage: "Код из аутентификатора",
  },
});

export const securityAlertMessages = defineMessages({
  blockedDescription: {
    id: "security-alert.blocked.description",
    defaultMessage:
      "Ваш аккаунт заблокирован. Для восстановления доступа обратитесь в службу поддержки",
  },
  blockedTitle: {
    id: "security-alert.blocked.title",
    defaultMessage: "Аккаунт заблокирован",
  },
  setupTitle: {
    id: "security-alert.setup.title",
    defaultMessage: "Верификация",
  },
  suspendedDescription: {
    id: "security-alert.suspended.description",
    defaultMessage:
      "После обновления настроек входа действует защитная пауза 24 часа для подтверждения личности и повторной смены 2FA",
  },
  suspendedTitle: {
    id: "security-alert.suspended.title",
    defaultMessage: "Тайм-аут безопасности",
  },
});

export const otpOverlayMessages = defineMessages({
  emailLabel: {
    id: "otp-overlay.email-label",
    defaultMessage: "Код из письма",
  },
  header: {
    id: "otp-overlay.header",
    defaultMessage: "Введите код подтверждения",
  },
  smsLabel: {
    id: "otp-overlay.sms-label",
    defaultMessage: "Код из SMS",
  },
});

export const otpFormMessages = defineMessages({
  emailLabel: {
    id: "otp-form.email.label",
    defaultMessage: "Код из письма отправлен на {email}",
  },
  smsLabel: {
    id: "otp-form.sms.label",
    defaultMessage: "Код из SMS отправлен на {phone}",
  },
  submitButton: {
    id: "otp-form.submit-button",
    defaultMessage: "Ввести",
  },
});

export const totpFormMessages = defineMessages({
  cancelButton: {
    id: "totp-form.cancel-button",
    defaultMessage: "Отменить",
  },
  clipboardError: {
    id: "totp-form.clipboard-error",
    defaultMessage: "Не удалось вставить из буфера обмена:",
  },
  codeLabel: {
    id: "totp-form.code-label",
    defaultMessage: "Код",
  },
  codePlaceholder: {
    id: "totp-form.code-placeholder",
    defaultMessage: "Код из аутентификатора",
  },
  confirmButton: {
    id: "totp-form.confirm-button",
    defaultMessage: "Подтвердить",
  },
  noAccessDialogBody: {
    id: "totp-form.no-access-dialog.body",
    defaultMessage:
      "Вы можете сбросить текущий аутентификатор и настроить новый.",
  },
  noAccessDialogTitle: {
    id: "totp-form.no-access-dialog.title",
    defaultMessage: "Нет доступа к аутентификатору",
  },
  noAccessLink: {
    id: "totp-form.no-access-link",
    defaultMessage: "Нет доступа к аутентификатору?",
  },
  pasteButton: {
    id: "totp-form.paste-button",
    defaultMessage: "Вставить",
  },
  resetButton: {
    id: "totp-form.reset-button",
    defaultMessage: "Сбросить аутентификатор",
  },
  resetConfirmDialogBody: {
    id: "totp-form.reset-confirm-dialog.body",
    defaultMessage: "Мы отправим письмо со ссылкой для изменения 2FA.",
  },
  resetConfirmDialogCheckbox: {
    id: "totp-form.reset-confirm-dialog.checkbox",
    defaultMessage: "Я понимаю, что торговля будет заблокирована на 24 часа",
  },
  resetConfirmDialogInstructions: {
    id: "totp-form.reset-confirm-dialog.instructions",
    defaultMessage: "<b>После подтверждения по ссылке:</b>",
  },
  resetConfirmDialogStep1: {
    id: "totp-form.reset-confirm-dialog.step1",
    defaultMessage: "Будет привязан новый аутентификатор.",
  },
  resetConfirmDialogStep2: {
    id: "totp-form.reset-confirm-dialog.step2",
    defaultMessage: "Созданы новые коды восстановления.",
  },
  resetConfirmDialogStep3: {
    id: "totp-form.reset-confirm-dialog.step3",
    defaultMessage:
      "Торговля будет временно <b>заблокирована на 24 часа</b> для защиты ваших средств.",
  },
  resetConfirmDialogTitle: {
    id: "totp-form.reset-confirm-dialog.title",
    defaultMessage: "Подтвердите изменение 2FA",
  },
  submitButton: {
    id: "totp-form.submit-button",
    defaultMessage: "Ввести",
  },
});

export const transactionRateMessages = defineMessages({
  get: {
    id: "transaction-rate.get",
    defaultMessage: "Вы получаете",
  },
  rate: {
    id: "transaction-rate.rate",
    defaultMessage: "Курс",
  },
});

export const totpOverlayMessages = defineMessages({
  title: {
    id: "totp.title",
    defaultMessage: "Введите код  из аутентификатора",
  },
});

export const transactionVerifyOverlayMessages = defineMessages({
  subTitle: {
    id: "transaction-verify.sub-title",
    defaultMessage: "Введите коды подтверждения",
  },
  title: {
    id: "transaction-verify.title",
    defaultMessage: "Подтвердите операцию",
  },
});
